import { Link } from "@tanstack/react-router";
import { Lock, ArrowLeft } from "lucide-react";

// PCR is closed. This notice replaces the old entry form (archived alongside as
// `PcrFormArchived.tsx`) so anyone who bookmarked /pcr gets a clear explanation
// instead of a 404 or a form that would fail on submit.
//
// This page is informational only. The real enforcement lives in
// `convex/pcr.ts`, where `submit` rejects every call.
export function PcrClosedPage() {
  return (
    <main className="flex-1 flex flex-col">
      <header className="bg-white border-b-4 border-[var(--hmg-red)] shadow-sm">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <img
            src="/hmg-logo.png"
            alt="Dr Sulaiman Al Habib Medical Group"
            width={376}
            height={86}
            className="h-10 sm:h-12 md:h-16 w-auto"
          />
        </div>
      </header>

      <section className="flex-1 flex items-center justify-center px-4 sm:px-6 py-12 bg-gradient-to-b from-white via-slate-50 to-slate-100">
        <div className="max-w-lg w-full bg-white rounded-2xl border border-slate-200 shadow-sm p-8 sm:p-10 text-center">
          <div className="w-16 h-16 rounded-2xl bg-slate-200 text-slate-600 flex items-center justify-center mx-auto mb-6">
            <Lock className="w-8 h-8" strokeWidth={1.8} />
          </div>

          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-3">
            PCR is closed
          </h1>

          <p className="text-slate-600 mb-2">
            Patient Care Reports are no longer accepted in this system. New PCRs
            cannot be started or submitted.
          </p>
          <p className="text-slate-500 text-sm mb-8">
            Previously submitted reports are retained and remain accessible to
            the system administrator only. If you need one, contact your
            supervisor.
          </p>

          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm font-semibold text-white bg-[var(--hmg-red)] hover:bg-[var(--hmg-red-dark)] rounded-lg px-5 py-2.5 transition"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to EMS Operations
          </Link>
        </div>
      </section>

      <footer className="bg-white border-t border-slate-200 py-4">
        <div className="max-w-6xl mx-auto px-6 text-center text-xs text-slate-500">
          &copy; {new Date().getFullYear()} Dr. Sulaiman Al Habib Medical Group
        </div>
      </footer>
    </main>
  );
}
